import { omit } from 'lodash'
import React from 'react'

import Select from '../../Select'
import { getCronTypes } from '../utils'

const CronTypeSelect = (props: any): React.ReactElement => {
  return (
    <Select
      {...props}
      direct
      options={omit(getCronTypes(), props.disabledTypes)}
    />
  )
}

export default CronTypeSelect
